import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { aiAsk } from "src/data/aiFunctions";

const AiContext = createContext();

export const AiProvider = ({ children }) => {
  const [prompt, setPrompt] = useState("");
  const [keikkaId, setKeikkaId] = useState(null);
  const [response, setResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (ownerAsiakasId, token) => {
    try {
      setIsLoading(true);
      const r = await aiAsk(prompt, ownerAsiakasId, conversationId, keikkaId, token);
      console.log(r);
      if (!r) {
        setErrorMessage("Virhe kyselyssä");
        setPrompt("");
        setResponse(["Virhe kyselyssä"]);
        return;
      }
      setErrorMessage("");
      setConversationId(r.msg.conversationId);
      if (!response) setResponse([r.msg.message]);
      else {
        response.push(r.msg.message);
        setResponse([...response]);
      }
    } catch (error) {
      console.error("AiLayout_Submit handleClick error: ", error);
      setErrorMessage("Virhe kyselyssä " + error.message);
      setResponse(["Virhe kyselyssä " + error.message]);
    } finally {
      setPrompt("");
      setIsLoading(false);
    }
  };

  return (
    <AiContext.Provider
      value={{
        prompt,
        setPrompt,
        keikkaId,
        setKeikkaId,
        response,
        setResponse,
        isLoading,
        setIsLoading,
        conversationId,
        setConversationId,
        errorMessage,
        setErrorMessage,
        handleSubmit,
      }}>
      {children}
    </AiContext.Provider>
  );
};

export const useAi = () => useContext(AiContext);

AiProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
